import { useCallback, useMemo } from 'react';
import currentGradYear from '../../../utilities/current-grad-year';

export const useGradeLevels = () => {
    const yearsToGraduation = useMemo( () => [0, 1, 2, 3], []);
    const labels = useMemo(() => [
        { singular: 'senior', plural: 'seniors' },
        { singular: 'junior', plural: 'juniors' },
        { singular: 'sophomore', plural: 'sophomores' },
        { singular: 'freshman', plural: 'freshmen' }
    ], []);
    const gradYears = useMemo(
        () => yearsToGraduation
            .map(gradeLevel => (currentGradYear + (gradeLevel)).toString()),
        [currentGradYear]
    );
    const gradYearLabels = useMemo(
        () => gradYears
            .reduce((gradYearLabels, gradYear, index) => ({ ...gradYearLabels, [gradYear]: labels[index] }), {}),
        [gradYears, labels]
    );
    const yearsToGraduationLabels = useMemo(
        () => yearsToGraduation
            .reduce((yearsToGraduationLabels, yearsToGraduation, index) => ({ ...yearsToGraduationLabels, [yearsToGraduation]: labels[index] }), {}),
    [yearsToGraduation, labels]);

    const getGradYearLabel = useCallback((gradYear) => {
        const label = gradYearLabels[gradYear];
        return label || 'unknown';
    }, [gradYearLabels]);

    const getYearsToGraduationLabel = useCallback((yearsToGraduationOffset) => {
        const label = yearsToGraduationLabels[yearsToGraduationOffset];
        return label || 'unknown';
    }, [yearsToGraduationLabels]);


    return {
        getGradYearLabel,
        getYearsToGraduationLabel,
        yearsToGraduation,
        labels,
        gradYears,
        gradYearLabels,
        yearsToGraduationLabels
    };
};
